import http from '../interceptors/Intercepter';

export const saveTemporaryObject = async (username, temporaryStorageVOToSave) => {
  try {
    const { data } = await http.post('/api/temporaryStorage/create', { username, temporaryStorageVOToSave });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveTemporaryObject = async (username) => {
  try {
    const { data } = await http.post('/api/temporaryStorage/view', { username, key: username });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
